import React, { Fragment } from "react";
import CommonDialog from "../../common/components/CommonDialog";
import { Box, Typography, useTheme } from "@mui/material";
import CommonButton from "../../common/components/CommonButton";
import CommonCard from "../../common/components/CommonCard";
import { useNavigate } from "react-router-dom";
import { Check, WatchLater } from "@mui/icons-material";

const CompleteProfile = ({
    addOpen,
    setAddOpen
}) => {
    const theme = useTheme();
    const navigate = useNavigate();
    return (
        <CommonDialog
            open={addOpen}
            size="xs"
            content={
                <Fragment>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            mt: 1,
                            mb: 1,
                            gap: 1
                        }}
                    >
                        <img src="./Images/message.png" alt="linked" width="50px" height="50px" />
                        <Typography fontWeight={600} mt={1}>Help us complete your profile</Typography>
                        <Box>
                            <Typography color={theme.palette.background.dark} fontSize={13} textAlign="center">
                                We need a few more details to accurately calculate your
                            </Typography>
                            <Typography color={theme.palette.background.dark} fontSize={13} textAlign="center">
                                <span style={{ fontWeight: 600, color: theme.palette.secondary.main }}>DCP Index Score</span> and give you the best college
                            </Typography>
                            <Typography color={theme.palette.background.dark} fontSize={13} textAlign="center">
                                recommendations.
                            </Typography>
                        </Box>
                    </Box>
                    <CommonCard
                        borderRadius={1}
                        border={`1px solid ${theme.palette.cardbackground.main}`}
                        background={theme.palette.cardbackground.secondary}
                        padding="10px"
                        paddingBottom="0px"
                        marginTop="20px"
                        content={
                            <Fragment>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 1,
                                        alignItems: 'center',
                                    }}
                                >
                                    <Box sx={{ background: 'green', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0.3 }}>
                                        <Check sx={{ color: 'white', fontSize: 12 }} />
                                    </Box>
                                    <Typography fontWeight={600} fontSize={15}>Calculate your personalized DCP Index Score</Typography>
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 1,
                                        alignItems: 'center',
                                        mt: 1,
                                    }}
                                >
                                    <Box sx={{ background: 'green', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0.3 }}>
                                        <Check sx={{ color: 'white', fontSize: 12 }} />
                                    </Box>
                                    <Typography fontWeight={600} fontSize={15}>Improve Dream / Target / Safe college accuracy</Typography>
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 1,
                                        alignItems: 'center',
                                        mt: 1,
                                    }}
                                >
                                    <Box sx={{ background: 'green', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0.3 }}>
                                        <Check sx={{ color: 'white', fontSize: 12 }} />
                                    </Box>
                                    <Typography fontWeight={600} fontSize={15}>Track deadlines and insights more precisely</Typography>
                                </Box>
                            </Fragment>
                        }
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'center',
                            mt: 3,
                            justifyContent: 'center'
                        }}
                    >
                        <WatchLater sx={{ color: theme.palette.primary.main, fontSize: 23 }} />
                        <Typography color={theme.palette.background.dark} fontSize={15} fontWeight={600}>It'll only take a few minute</Typography>
                    </Box>
                    <CommonButton
                        label="Create"
                        size="small"
                        background={theme.palette.secondary.main}
                        color={theme.palette.background.main}
                        fontWeight={700}
                        marginBottom="5px"
                        marginTop="15px"
                        handleClick={() => {
                            localStorage.setItem('permenentclose', false);
                            setAddOpen(false);
                            navigate('/my-profile');
                        }}
                    />
                    <CommonButton
                        label="Maybe later"
                        size="small"
                        background='transparent'
                        color={theme.palette.background.dark}
                        fontWeight={600}
                        fontSize={15}
                        marginBottom="0px"
                        handleClick={() => {
                            localStorage.setItem('permenentclose', false);
                            setAddOpen(false);
                        }}
                    />
                </Fragment>
            }
        />
    )
}

export default CompleteProfile;